import ApproveAllCard from "./approveAllCard";
export default ApproveAllCard;